interface FilterToolbarProps {
  totalCount: number;
}

export default function FilterToolbar({
  totalCount,
}: FilterToolbarProps) {
  return (
    <div className="w-full bg-white border-b border-ink-100 px-4 md:px-6 lg:px-10 py-3">
      <div className="flex items-center gap-3">
        <span className="text-sm text-ink-500">
          {totalCount} products found
        </span>
      </div>
    </div>
  );
}